import { useState } from "react";
import { Link } from "react-router-dom";
import { AppHeader } from "../components/AppHeader";
import { Toaster } from "sonner";
import { ArrowLeft, Users, School, BookOpen, Link2, CalendarRange } from "lucide-react";
import TeachersManager from "../components/admin/TeachersManager";
import ClassesManager from "../components/admin/ClassesManager";
import SubjectsManager from "../components/admin/SubjectsManager";
import AssignmentsManager from "../components/admin/AssignmentsManager";
import PeriodsManager from "../components/admin/PeriodsManager";

const TABS = [
  { key: "teachers", label: "Professeurs", icon: Users },
  { key: "classes", label: "Classes & Élèves", icon: School },
  { key: "subjects", label: "Matières", icon: BookOpen },
  { key: "assignments", label: "Affectations", icon: Link2 },
  { key: "periods", label: "Trimestres", icon: CalendarRange },
];

export default function AdminManagement() {
  const [tab, setTab] = useState("teachers");

  return (
    <div className="min-h-screen bg-[var(--cream)]">
      <AppHeader />
      <Toaster richColors position="top-right" />
      <main className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
        <Link
          to="/admin"
          className="inline-flex items-center gap-2 text-sm text-[var(--ink-soft)] hover:text-[var(--maroon)] transition-colors"
          data-testid="back-to-admin-link"
        >
          <ArrowLeft size={16} /> Retour au tableau de bord
        </Link>

        <div className="mt-6">
          <div className="eyebrow">Administration</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl font-semibold mt-2">Gestion de l'établissement</h1>
          <p className="mt-3 text-[var(--ink-soft)] max-w-2xl">
            Créez et modifiez les comptes professeurs, les classes, les élèves, les matières,
            les affectations et le calendrier des trimestres.
          </p>
        </div>

        <div className="mt-8 flex gap-1 border-b border-[var(--parchment-2)] overflow-x-auto" data-testid="management-tabs">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                data-testid={`mgmt-tab-${t.key}`}
                className={`inline-flex items-center gap-2 px-5 py-3 text-sm font-medium border-b-2 whitespace-nowrap transition ${
                  tab === t.key
                    ? "border-[var(--maroon)] text-[var(--maroon)]"
                    : "border-transparent text-[var(--ink-soft)] hover:text-[var(--ink)]"
                }`}
              >
                <Icon size={16} /> {t.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6">
          {tab === "teachers" && <TeachersManager />}
          {tab === "classes" && <ClassesManager />}
          {tab === "subjects" && <SubjectsManager />}
          {tab === "assignments" && <AssignmentsManager />}
          {tab === "periods" && <PeriodsManager />}
        </div>
      </main>
    </div>
  );
}
